import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import moment from "moment";
import defaultpp from "../../../images/profile.png";
import {
  openDialog,
} from "../../../store/slices/dialog/dialogSlice";
import {
  CONFIRM_DIALOG,
  EDIT_DAYOFF,
  START_LEAVE_DIALOG,
} from "../../../store/slices/utils/dialogEnum";
import { useDispatch } from "react-redux";
import {
  setEnterDateModel,
  setSelectedId,
} from "../../../store/slices/user/userSlice";
import { LEAVED, SAVED } from "../../../workingStatus";

const PersonelCard = ({ personel, onDayoff }) => {
  const fullName = `${personel.firstName} ${personel.lastName}`;
  const dispatch = useDispatch();

  const onStartLeave = () => {
    dispatch(
      setEnterDateModel({
        userId: personel.id,
        isStartDate: personel.workingStatusId === SAVED,
        personelName: `${personel.firstName} ${personel.lastName}`,
        departmentName: personel.birim || "",
      })
    );
    dispatch(openDialog(START_LEAVE_DIALOG));
  };

  const onDelete = (personelId) => {
    dispatch(setSelectedId(personelId));
    dispatch(openDialog(CONFIRM_DIALOG));
  };

  const onEditDayoff = () => {
    dispatch(setSelectedId(personel.id));
    dispatch(openDialog(EDIT_DAYOFF));
  }

  return (
    <Card
      sx={{
        mx: "auto",
        my: 2,
        borderRadius: 5,
        boxShadow: 6,
        bgcolor: "#f8fafc",
        width: "100%",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-4px) scale(1.02)",
          boxShadow: 12,
        },
      }}
    >
      <CardHeader
        avatar={
          <Avatar
            src={defaultpp}
            alt={fullName}
            sx={{
              width: 80,
              height: 80,
              bgcolor: "primary.light",
              border: "2px solid #fff",
              boxShadow: 2,
            }}
          />
        }
        title={
          <Typography
            variant="h6"
            sx={{
              color: "primary.main",
              fontWeight: 700,
              letterSpacing: 0.5,
              fontSize: "1.25rem",
            }}
          >
            {fullName}
          </Typography>
        }
        subheader={
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 500 }}
          >
            {personel.birim}
          </Typography>
        }
        sx={{ pb: 0, pt: 2 }}
      />
      <Divider />
      <CardContent sx={{ py: 2.5, px: 3 }}>
        <Stack spacing={1}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Çalışma Durumu:
            </Typography>
            <Typography variant="body2">
              {personel.workingStatusName}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Durum:
            </Typography>
            {personel.isActive && !(personel.workingStatusId === LEAVED && personel.workingEndDate) ? (
              <>
                <CheckCircleIcon sx={{ color: "success.main", fontSize: 18 }} />
                <Typography variant="body2" sx={{ color: "success.main", fontWeight: 600 }}>
                  Aktif
                </Typography>
              </>
            ) : (
              <>
                <CancelIcon sx={{ color: "error.main", fontSize: 18 }} />
                <Typography variant="body2" sx={{ color: "error.main", fontWeight: 600 }}>
                  Pasif
                </Typography>
              </>
            )}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Email:
            </Typography>
            <Typography variant="body2">{personel.email}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Başlama:
            </Typography>
            <Typography variant="body2">
              {personel.workingStartDate
                ? moment(personel.workingStartDate).format("DD/MM/YYYY")
                : "---"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Ayrılma:
            </Typography>
            <Typography variant="body2">
              {personel.workingEndDate
                ? moment(personel.workingEndDate).format("DD/MM/YYYY")
                : "---"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Rol:
            </Typography>
            <Typography variant="body2">{personel.roleName}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Departman:
            </Typography>
            <Typography variant="body2">{personel.birim}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Takım:
            </Typography>
            <Typography variant="body2">{personel.teamNames}</Typography>
          </Box>
        </Stack>
      </CardContent>
      <Divider />
      <CardActions
        sx={{
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          px: 2,
          pb: 2,
          pt: 1,
        }}
      >
        <Button
          variant={personel.workingStatusId === LEAVED ? "outlined" : "contained"}
          color={personel.workingStatusId === SAVED ? "success" : "error"}
          fullWidth
          sx={{
            fontWeight: 600,
            letterSpacing: 0.5,
            boxShadow: personel.workingStatusId === LEAVED ? 0 : 2,
            mb: 0.5,
          }}
          onClick={() => onStartLeave(personel)}
        >
          {personel.workingStatusId === SAVED
            ? "Başlayış Yap"
            : personel.workingStatusId === LEAVED
            ? "Tarihi Düzenle"
            : "Ayrılış Yap"}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          component={Link}
          sx={{ fontWeight: 600, letterSpacing: 0.5, mb: 0.5 }}
          to={`/personel-detail/${personel.id}`}
        >
          Detay
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          sx={{ fontWeight: 600, letterSpacing: 0.5, mb: 0.5 }}
          component={Link}
          to={`/edit-personel/${personel.id}`}
        >
          Güncelle
        </Button>
        <Button
          variant="outlined"
          color="success"
          fullWidth
          sx={{ fontWeight: 600, letterSpacing: 0.5, mb: 0.5 }}
          onClick={() => onEditDayoff(personel)}
        >
          İzinler
        </Button>
        <Button
          variant="outlined"
          color="error"
          fullWidth
          sx={{ fontWeight: 600, letterSpacing: 0.5 }}
          onClick={() => onDelete(personel.id)}
        >
          Sil
        </Button>
      </CardActions>
    </Card>
  );
};

export default PersonelCard;
